<template>
  <div class="top_wrapper">
    <div class="top_left">
      <h1>
        <img src="../../../assets/image/logo.png" alt class="logo" />
      </h1>
      <a-menu v-model="current" mode="horizontal" theme="dark" class="top-menu">
        <a-menu-item v-for="v in menuList" style="font-weight:800" :key="v.fullPath" @click="$router.push(v.fullPath)">{{ v.name }}</a-menu-item>
      </a-menu>
    </div>
    <div class="top_right">
      <HeaderSearch></HeaderSearch>
      <HeaderHelp style="margin-left:16px;"></HeaderHelp>
      <HeaderNotice style="margin:0 16px;"></HeaderNotice>
      <HeaderAvatar></HeaderAvatar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderAvatar from './HeaderAvatar';
import HeaderNotice from './HeaderNotice';
import HeaderSearch from './HeaderSearch';
import HeaderHelp from './HeaderHelp';
import Event from '@/utils/event';

export default {
  components: { HeaderAvatar, HeaderNotice, HeaderSearch, HeaderHelp },
  data() {
    return {
      current: [],
      menuList: []
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    let tmp = document.getElementsByClassName('top_wrapper')[0];
    if (/hubble/.test(document.URL)) {
      tmp.style.background = '#EA8015';
    } else if (/pretianchi/.test(document.URL)) {
      tmp.style.background = '#69943F';
    }
  },
  methods: {
    initMenu() {
      // 初始化头部导航
      const { permissions } = this.userInfo || {};
      this.menuList = [];
      permissions.forEach(item => {
        if (item.type === 0) {
          this.menuList.push({
            fullPath: item.fullPath,
            name: item.name
          });
        }
        if (this.$route.path.includes(item.fullPath)) {
          //初始化选中菜单
          this.current = [item.fullPath];
        }
      });
    }
  },
  created() {
    this.initMenu();
    Event.$on('setPermission', () => {
      this.initMenu();
    });
  }
};
</script>

<style lang="less" scoped>
.top_wrapper {
  background: #001529;
  top: 0;
  height: 46px;
  width: 100%;
  position: fixed;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  .top_left {
    display: flex;
    .logo {
      width: 150px;
    }
  }
  .top_right {
    padding-right: 20px;
    display: flex;
    align-items: center;
  }
  .top-menu {
    background: inherit;
  }
}
</style>
